export const MODULE_NAME = 'USER_MODULE';
